<script setup>

import { computed, onBeforeMount, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import setTooltip from "../assets/js/tooltip.js";
import axios from "axios";
import bootstrap from "bootstrap/dist/js/bootstrap";
import { toast } from 'vue3-toastify';
import loadGif from "@/assets/img/loading.gif"
import 'animate.css';
import calculator from "./calculator.vue";
import CategoriesOptions from "./CategoriesOptions.vue";
import emitter from "../assets/js/eventBus.js";
import cookies from "../assets/js/cookies.js";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

let selectCategories = {};

const money = {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false /* doesn't work with directive */
        }

onBeforeMount(() => {

    let session = cookies.get('user_agive_session');

    store.state.is_card = false;

    store.state.transaction_value = {
        value: 0
    }

    store.state.accounts = [];
    store.state.cards = [];
    store.state.categoriesExpense = {};
    store.state.categoriesRevenue = {};
    store.state.savingTransaction = false;
    store.state.modalColor = '';
    store.state.objetives = [];
    store.state.suggestions = [];
    store.state.customers = [];
    store.state.suppliers = [];

    store.state.validation = {
        descHasError: false,
        descMessageError: '',
    };

    let day = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();

    store.state.current_date = year+ '-' + (month < 10 ? '0'+month : month) + '-' + (day < 10 ? '0'+ day : day);

    store.state.transation = {
        type: '',
        description: '',
        amount: 0,
        date: store.state.current_date,
        account: '',
        account_name: '',
        account_destiny: '',
        account_destiny_name: '',
        category: '',
        category_name: '',
        category_icon: '',
        category_color: '',
        recurrence_checked: false,
        recurrence: '',
        recurrence_period: 'monthly',
        initial_installment: 1,
        current_installment: 1,
        end_installment: 1,
        payed: false,
        id: '',
        transaction_id: '',
        invoice_id: '',
        card_id: '',
        howUpdate: '',
        amount_paid: 0,
        ammount_unpaid: 0,
        observation: '',
        objetive_checked: false,
        objetive: '',
        customer_supplier: '',
        customer_supplier_name: ''
    }

    if(session !== null){

        getCards();
        getAccounts();
        getExpenseCategories();
        getRevenueCategories();
        getObjetives();
        get_customers_suppliers();

    }

})

onMounted(() => {

    emitter.on('set-type', setType);
    emitter.on('edit-transaction', editTrasaction);
    emitter.on('delete-transaction', deleteTransation);
    emitter.on('receive-data', (res) => {

        store.state.transation.account = '';
        store.state.is_card = false;
        store.state.transation.payed = false;

        let fullURL = window.location.href;

        if(fullURL.indexOf('fatura') > -1){

            store.state.transation.account = res.data;
            store.state.is_card = true;
        }
        
    });
    
    setTooltip();

});

onUnmounted(() => {
    emitter.off('set-type', setType);
    emitter.off('edit-transaction', editTrasaction);
    emitter.off('delete-transaction', deleteTransation);
    emitter.off('receive-data', () => {});
});

const getAccounts = async () => {

    axios.get('accounts?archived=No')
    .then(res => {
        
        if(res.status == 200){

            store.state.accounts = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getCards = async () => {

    axios.get('credit-cards')
    .then(res => {
        
        if(res.status == 200){

            store.state.cards = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getExpenseCategories = async () => {

    axios.get('categories?type=despesa')
    .then(res => {
        
        if(res.status == 200){

            store.state.categoriesExpense = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getRevenueCategories = async () => {

    axios.get('categories?type=receita')
    .then(res => {

    if(res.status == 200){

        store.state.categoriesRevenue = res.data;

    }

    })
    .catch(err => {
        console.error(err); 
    })

}

const setType = (type, is_card = false) => {

    store.state.is_card = is_card;

    emitter.emit('get-data', { data: '' });

    if(type.data == 'despesa'){
        selectCategories = store.state.categoriesExpense;
        store.state.modalColor = '-danger';
    }
    else if(type.data == 'receita'){
        selectCategories = store.state.categoriesRevenue;
        store.state.modalColor = '-success';
    }
    else{
        store.state.modalColor = '-warning';
        store.state.transation.description = 'Transferência';
        store.state.transation.payed = true;
        store.state.transation.category = 2;
    }

    store.state.transation.type = type.data;

}

const clearFields = () => {

    store.state.transaction_value.value = 0

    store.state.transation = {
        type: '',
        description: '',
        amount: 0,
        date: store.state.current_date,
        account: '',
        account_name: '',
        account_destiny: '',
        account_destiny_name: '',
        category: '',
        category_name: '',
        category_icon: '',
        category_color: '',
        recurrence_checked: false,
        recurrence: '',
        recurrence_period: 'monthly',
        initial_installment: 1,
        current_installment: 1,
        end_installment: 1,
        payed: false,
        id: '',
        transaction_id: '',
        invoice_id: '',
        card_id: '',
        howUpdate: '',
        amount_paid: 0,
        ammount_unpaid: 0,
        observation: '',
        objetive: '',
        customer_supplier: '',
        customer_supplier_name: ''
    }

    store.state.suggestions = [];
}

const editTrasaction = (res) => {

    let data = res.data;

    store.state.transaction_value.value = formatMoney(data.amount);

    store.state.transation = {
        type: data.type,
        description: data.description,
        amount: formatMoney(data.amount),
        date: data.date,
        account: data.account_id > 0 ? data.account_id+'-bank': data.card_id+'-card',
        account_name: data.account_name,
        account_destiny: data.account_destiny_id > 0 ? data.account_destiny_id+'-bank': '',
        account_destiny_name: data.account_destiny_name,
        category: data.category_id,
        category_name: data.category_name,
        category_icon: data.category_icon,
        category_color: data.category_color,
        recurrence_checked: false,
        recurrence: data.recurrence,
        recurrence_period: '',
        initial_installment: 1,
        current_installment: data.current_installment,
        end_installment: data.end_installment,
        payed: data.status == 'Unpaid' ? false : true,
        id: data.id,
        invoice_id: data.invoice_id,
        card_id: data.card_id,
        transaction_id: data.transaction_id,
        howUpdate: 'just_this',
        amount_paid: data.amount_paid,
        ammount_unpaid: data.ammount_unpaid,
        observation: data.observation,
        objetive: data.objetive_id,
        objetive_checked: data.objetive_id > 0 ? true : false,
        customer_supplier: data.customer_suplier_id,
        customer_supplier_name: data.customer_supplier_name
    }

}

const submitTransaction = async () => {

    store.state.savingTransaction = true;

    let data = new FormData();

    store.state.validation.descHasError = false;

    store.state.transation.amount = store.state.transaction_value.value.replace('R$ ', '');

    data.append('type', store.state.transation.type);
    data.append('description', store.state.transation.description);
    data.append('amount', store.state.transation.amount);
    data.append('date', store.state.transation.date);
    data.append('account', store.state.transation.account);
    data.append('account_destiny', store.state.transation.account_destiny);
    data.append('category', store.state.transation.category);
    data.append('recurrence', store.state.transation.recurrence);
    data.append('period', store.state.transation.recurrence_period);
    data.append('initial_installment', store.state.transation.initial_installment);
    data.append('end_installment', store.state.transation.end_installment);
    data.append('payed', store.state.transation.payed ? 'Paid' : '');
    data.append('observation', store.state.transation.observation);
    data.append('objetive', store.state.transation.objetive);
    data.append('customer_supplier', store.state.transation.customer_supplier)

    let url = '/transactions';
    let toast_message = t('message.transactions.created');

    if(store.state.transation.id != ''){

        url = '/transactions/update/'+store.state.transation.id;
        toast_message = t('message.transactions.updated');

        data.append('transaction_id', store.state.transation.transaction_id);
        data.append('howUpdate', store.state.transation.howUpdate);
        data.append('invoice_id', store.state.transation.invoice_id);
    }

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'description'){
                    store.state.validation.descHasError = true;
                    store.state.validation.descMessageError = value[1];
                }
                else if(value[0] == 'account'){
                    store.state.validation.accountError = true;
                    store.state.validation.accountMessageError = value[1];
                }
                else if(value[0] == 'category'){
                    store.state.validation.categorryError = true;
                    store.state.validation.categoryMessageError = value[1];
                }

            })

            store.state.savingTransaction = false;

        }
        else{

            store.state.validation = {
                descHasError: false,
                descMessageError: '',
            };

            closeModal('addTransaction');

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            store.state.savingTransaction = false;

            let retorno = {
                editing: false,
                transaction_id: ''
            };

            if(store.state.transation.id != ''){
                retorno.editing = true;
                retorno.transaction_id = store.state.transation.id;
            }

            emitter.emit('load-data', retorno);
            closeModal('payTransaction');
            clearFields();

        }

    })
    .catch(err => {
        console.error(err); 

        toast('Não foi possível realizar a operação, tente mais tarde (Erro '+err.response.status+')', {
            autoClose: 1000,
            theme: "auto",
            type: "error",
            transition: "slide"
        });

        store.state.savingTransaction = false;

    })

}

const deleteTransation = (id, transaction_id, type) => {

    let url = '/transactions/delete/'+id;

    let data = new FormData();

    data.append('howDelete', type);
    data.append('transaction_id', transaction_id);

    axios.post(url, data)
    .then(res => {
        
        if(!res.data.error){

            toast(t('message.transactions.deleted'), {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            closeModal('deleteTransaction');
            emitter.emit('load-data', { data: {editing:true, transaction_id:transaction_id} });
            clearFields();

        }

    })
    .catch(err => {
        console.error(err); 
    })

}

const closeModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.hide();

}

const formatMoney = (v) => {
    let total = parseFloat(v);

    return total.toLocaleString(t('message.global.date_language'), {
            style: "currency",
            currency: "BRL",
        });
}

const updateValue = (value) => {
    store.state.transaction_value.value = formatMoney(value);
}

const getObjetives = async () => {

    axios.get('objetives')
    .then(res => {
        
        if(res.status == 200){

            store.state.objetives = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const autoComplete = async () => {

    if(store.state.transation.description.length >= 3 && store.state.transation.id == ''){

        let url = 'transactions/suggestion/'+store.state.transation.type+'/'+store.state.transation.description;

        if(store.state.is_card){
            url = url + '?isCard=Yes';
        }

        axios.get(url)
        .then(res => {
            
            if(res.status == 200){

                store.state.suggestions = res.data;

            }
            
        })
        .catch(err => {
            console.error(err); 
        })

    }
    else{
        store.state.suggestions = [];
    }

}

const selectAutoComplete = (suggestion) => {

    store.state.transation.description = suggestion.description;
    store.state.transaction_value.value = formatMoney(suggestion.amount);
    store.state.transation.category = suggestion.category_id;
    store.state.transation.account = suggestion.card_id == null ? suggestion.account_id+'-bank': suggestion.card_id+'-card';

    if(suggestion.objetive_id > 0){

        store.state.transation.objetive_checked = true;
        store.state.transation.objetive = suggestion.objetive_id;

    }

    store.state.suggestions = [];

}

const closeAutoComplete = () => {

    store.state.suggestions = [];

}

const formatDate = (d) => {
    
    let date = new Date(d);
    
    return date.toLocaleDateString(t('message.global.date_language'), {timeZone: 'UTC'});

}

const get_customers_suppliers = () => {

    axios.get('customers-suppliers?type=C')
        .then(res => {
            
            if(res.status == 200){

                store.state.customers = res.data;

            }
            
        })
        .catch(err => {
            console.error(err); 
        })

    axios.get('customers-suppliers?type=S')
        .then(res => {
            
            if(res.status == 200){

                store.state.suppliers = res.data;

            }
            
        })
        .catch(err => {
            console.error(err); 
        })

}

const addLinebreaks = (anyString) => {
        if(anyString){
            return anyString.replaceAll("\n", "<br />\r\n");
        }
        
    }

</script>
<template>

    <div class="modal fade" id="addTransaction" tabindex="-1" aria-labelledby="addTransaction" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content border-4" v-bind:class="{
                        'darkmode': darkMode,
                        'border-danger': store.state.transation.type == 'despesa',
                        'border-success': store.state.transation.type == 'receita',
                        'border-warning': store.state.transation.type == 'transferência'
                    }">

                <div class="modal-header">
                    <b v-if="store.state.transation.type == 'despesa'">
                                {{ store.state.transation.id != '' ? t('message.transactions.edit_expense') : t('message.transactions.new_expense') }}
                            </b>
                            <b v-else-if="store.state.transation.type == 'receita'">
                                {{ store.state.transation.id != '' ? t('message.transactions.edit_revenue') : t('message.transactions.new_revenue') }}
                            </b>
                            <b v-else>
                                {{ store.state.transation.id != '' ? t('message.transactions.edit_transfer') : t('message.transactions.new_transfer') }}
                            </b>
                    <a type="button" data-bs-dismiss="modal" @click="clearFields()">
                                <i class="fal fa-times-circle fa-lg"></i>
                            </a>
                </div>
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">
                    
                        <div class="col-12 col-lg-11 mx-auto mt-3 mb-3">

                            <div class="row">

                                <div class="col-12 mb-3">
                                    <label for="transactionDesc">{{ t('message.transactions.description') }}</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="transactionDesc"
                                        name="transactionDesc"
                                        v-model="store.state.transation.description"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.descHasError,
                                            'darkmode': darkMode,
                                        }"
                                        @input="autoComplete"
                                    >
                                    <ul class="auto-complete-list border rounded mt-1 shadow" v-if="store.state.suggestions.length > 0" v-bind:class="{
                                            'darkmode': darkMode,
                                            'bg-white': !darkMode
                                        }">
                                        <li class="pt-2 pb-2">
                                            <div class="row">
                                                <div class="col-9">
                                                    <h6 class="text-sm">{{t('message.transactions.suggestions')}}</h6>
                                                </div>
                                                <div class="col-2 text-end">
                                                    <a @click="closeAutoComplete"><i class="fas fa-times"></i></a>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="pt-3 pb-3 text-sm" v-for="suggestion in store.state.suggestions" :key="suggestion.id" @click="selectAutoComplete(suggestion)">
                                            <div class="row">
                                                <div class="col-7">
                                                   <img :src="suggestion.account_icon" alt="" width="25" class="rounded-5 me-2"> {{ suggestion.description }} - {{ suggestion.category_name }} 
                                                </div>
                                                <div class="col-4 text-end">
                                                    {{formatMoney(suggestion.amount)}}
                                                </div>
                                            </div>
                                            
                                        </li>
                                    </ul>
                                    <div id="categoryNameFeedback" class="invalid-feedback">
                                        {{ store.state.validation.descMessageError }}
                                    </div>
                                </div>

                                <div class="col-6 mb-3">
                                    <label for="transactionAmounti">
                                        <div class="row">
                                            <div class="col-6">
                                                {{t('message.transactions.amount')}}
                                            </div>
                                            <div class="col-6">
                                                <calculator @updateValue="updateValue" :value="store.state.transaction_value.value"></calculator>
                                            </div>
                                        </div>                                        
                                    </label>
                                    <input 
                                        type="tel" 
                                        class="form-control form-control-lg" 
                                        id="transactionAmount"
                                        name="transactionAmount"
                                        v-model.lazy="store.state.transaction_value.value" 
                                        v-money="money"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-6 mb-3">
                                    <label for="transactionDate">{{t('message.transactions.date')}}</label>
                                    <input 
                                        type="date" 
                                        class="form-control form-control-lg" 
                                        id="transactionDate"
                                        name="transactionDate"
                                        v-model="store.state.transation.date"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div v-if="store.state.transation.type == 'receita' || store.state.transation.type == 'despesa'" class="col-6 mb-3">
                                    <label for="transactionAccount">{{t('message.transactions.account_card')}} <i class="fal fa-info-circle" v-tooltip="{
                                                content:t('message.transactions.account_card_tooltip'),
                                                distance: 15,
                                                html: true
                                            }"></i></label>
                                    <select 
                                        class="form-select form-select-lg" 
                                        aria-label="Conta/Cartão" 
                                        v-model="store.state.transation.account"
                                        id="transactionAccount"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.accountError,
                                            'darkmode': darkMode,
                                        }"
                                    >
                                            <option value="" selected disabled>{{t('message.global.select_option')}}</option>
                                            <optgroup label="Contas">
                                                <option
                                                    v-for="(account, index) in store.state.accounts" :key="index"
                                                    :value="account.id+'-bank'"
                                                >
                                                    {{ account.name }}
                                                </option>
                                            </optgroup>

                                            <optgroup label="Cartões">
                                                <option
                                                    v-for="(card, index) in store.state.cards" :key="index"
                                                    :value="card.id+'-card'"
                                                >
                                                    {{ card.name }}
                                                </option>
                                            </optgroup>
                                    </select>
                                    <div id="parentSelectFeedback" class="invalid-feedback">
                                        {{ store.state.validation.accountMessageError }}
                                    </div>
                                </div>

                                <div v-if="store.state.transation.type == 'transferência'" class="col-6 mb-3">
                                    <label for="transactionAccountSender">{{ t('message.transactions.account_out') }}<i class="fal fa-info-circle"></i></label>
                                    <select 
                                        class="form-select form-select-lg" 
                                        aria-label="Conta/Cartão" 
                                        v-model="store.state.transation.account"
                                        id="transactionAccountSender"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.accountError,
                                            'darkmode': darkMode,
                                        }"                                      
                                    >
                                            <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                                            <option
                                                v-for="(account, index) in store.state.accounts" :key="index"
                                                :value="account.id+'-bank'"
                                            >
                                                {{ account.name }}
                                            </option>
                                    </select>
                                    <div class="invalid-feedback">
                                        {{ store.state.validation.accountMessageError }}
                                    </div>
                                </div>

                                <div v-if="store.state.transation.type == 'transferência'" class="col-6 mb-3">
                                    <label for="transactionAccountDestiny">{{ t('message.transactions.account_in') }} <i class="fal fa-info-circle" v-tooltip="{
                                                content:'Para cadastrar uma nova conta<br>acesse o menu <b>configurações > Contas</b>',
                                                distance: 15,
                                                html: true
                                            }"></i></label>
                                    <select 
                                        class="form-select form-select-lg" 
                                        aria-label="Conta/Cartão" 
                                        v-model="store.state.transation.account_destiny"
                                        id="transactionAccountDestiny"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                            <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                                            <option
                                                v-for="(account, index) in store.state.accounts" :key="index"
                                                :value="account.id+'-bank'"
                                            >
                                                {{ account.name }}
                                            </option>
                                    </select>
                                    <div id="parentSelectFeedback" class="invalid-feedback">
                                        {{ store.state.validation.parentMessageError }}
                                    </div>
                                </div>

                                <div v-if="store.state.transation.type == 'receita' || store.state.transation.type == 'despesa'" class="col-6 mb-3">
                                    <label for="categoryName">{{ t('message.menu.category') }} <i class="fal fa-info-circle" v-tooltip="{
                                                content:t('message.transactions.category_tooltip'),
                                                distance: 15,
                                                html: true
                                            }"></i></label>
                                    <select 
                                        class="form-select form-select-lg selectpicker" 
                                        aria-label="Categoria" 
                                        v-model="store.state.transation.category"
                                        id="parentSelect"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.categorryError,
                                            'darkmode': darkMode,
                                        }"
                                    >
                                            <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                                            <CategoriesOptions :categories="selectCategories"></CategoriesOptions>
                
                                    </select>
                                    <div id="parentSelectFeedback" class="invalid-feedback">
                                        {{ store.state.validation.categoryMessageError }}
                                    </div>
                                </div>

                                <div v-if="(store.state.transation.type == 'receita' || (store.state.transation.type == 'despesa' && !store.state.is_card))" class="col-12 mb-3">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="transactionObjetive" v-model="store.state.transation.objetive_checked" :disabled="store.state.transation.id != ''">
                                        <label class="form-check-label" for="transactionObjetive">{{ store.state.transation.type == 'despesa' ? t('message.transactions.objetive_expense') : t('message.transactions.objetive_revenue') }}</label>
                                    </div>
                                </div>

                                <div v-if="(store.state.transation.type == 'receita' || store.state.transation.type == 'despesa') && (store.state.transation.objetive_checked)" class="col-12 mb-3">
                                    <label for="categoryName">{{ t('message.global.objetive') }} <i class="fal fa-info-circle" v-tooltip="{
                                                content:t('message.transactions.objetive_tooltip'),
                                                distance: 15,
                                                html: true
                                            }"></i></label>
                                    <select 
                                        class="form-select form-select-lg selectpicker" 
                                        aria-label="Objetivo" 
                                        v-model="store.state.transation.objetive"
                                        id="parentSelect"
                                        :disabled="store.state.transation.id != ''"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                            <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                                            <option
                                                v-for="(objetive, index) in store.state.objetives" :key="index"
                                                :value="objetive.id"
                                            >
                                                {{ objetive.name }}
                                            </option>
                
                                    </select>
                                    
                                </div>

                                <div v-if="(store.state.transation.type == 'receita' || store.state.transation.type == 'despesa') && (cookies.get('user_agive_account_type') === 'J')" class="col-12 mb-3">
                                    <label for="customerName">{{ t('message.transactions.customer_stakeholder') }} <i class="fal fa-info-circle" v-tooltip="{
                                                content:t('message.transactions.customer_stakeholder_tooltip'),
                                                distance: 15,
                                                html: true
                                            }"></i></label>
                                    <select 
                                        class="form-select form-select-lg" 
                                        aria-label="Cliente / Fornecedor" 
                                        v-model="store.state.transation.customer_supplier"
                                        id="customerName"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                            <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                                            <optgroup label="Clientes">
                                                <option
                                                    v-for="(customer, index) in store.state.customers" :key="index"
                                                    :value="customer.id"
                                                >
                                                    {{ customer.name }}
                                                </option>
                                            </optgroup>

                                            <optgroup label="Fornecedores">
                                                <option
                                                    v-for="(supplier, index) in store.state.suppliers" :key="index"
                                                    :value="supplier.id"
                                                >
                                                    {{ supplier.name }}
                                                </option>
                                            </optgroup>
                                    </select>
                                    
                                </div>

                                <div class="col-12 mb-3">
                                    <label for="transactionObservation">{{ t('message.transactions.observation') }}</label>
                                    <textarea id="transactionObservation" rows="4" class="form-control" v-model="store.state.transation.observation" v-bind:class="{
                                            'darkmode': darkMode,
                                        }"></textarea>
                                </div>

                                <div v-if="store.state.transation.id == ''" class="col-12 mb-3">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="transactionRecurrence" v-model="store.state.transation.recurrence_checked">
                                        <label class="form-check-label" for="transactionRecurrence">{{ t('message.transactions.repeat') }}</label>
                                    </div>
                                </div>

                                <div v-if="store.state.transation.recurrence_checked && store.state.transation.id == ''" class="col-12 mb-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="transactionRecurrenceType" id="transactionRecurrenceType1" value="Fixed" v-model="store.state.transation.recurrence">
                                        <label class="form-check-label" for="transactionRecurrenceType1">
                                            {{ store.state.transation.type == 'despesa' ? t('message.transactions.fixed_expense') : t('message.transactions.fixed_revenue')}}
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="transactionRecurrenceType" id="transactionRecurrenceType2" value="Installments" v-model="store.state.transation.recurrence">
                                        <label class="form-check-label" for="transactionRecurrenceType2">
                                            {{ store.state.transation.type == 'despesa' ? t('message.transactions.instaltement_expense') : t('message.transactions.instaltement_revenue')}}
                                        </label>
                                    </div>
                                </div>

                                <div v-if="store.state.transation.recurrence_checked && store.state.transation.recurrence == 'Installments' && store.state.transation.id == ''" class="col-6 mb-3">

                                    <label for="transactionInitialI">{{ t('message.transactions.initial_instaltement') }}</label>
                                    <select class="form-select form-select-lg"
                                        v-model="store.state.transation.initial_installment"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                        <option v-for="n in 640" :key="n"
                                            :value="n"
                                        >
                                            {{n}}
                                        </option>
                                    </select>

                                </div>

                                <div v-if="store.state.transation.recurrence_checked && store.state.transation.recurrence == 'Installments' && store.state.transation.id == ''" class="col-6 mb-3">

                                    <label for="transactionInitialI">{{ t('message.transactions.quantity_instaltement') }}</label>
                                    <select class="form-select form-select-lg"
                                        v-model="store.state.transation.end_installment"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                        <option v-for="n in 640" :key="n"
                                            :value="n"
                                        >
                                            {{n}}
                                        </option>
                                    </select>

                                </div>

                                <div v-if="store.state.transation.recurrence_checked && store.state.transation.id == '' && (store.state.transation.recurrence == 'Fixed' || store.state.transation.recurrence == 'Installments')" class="col-12 mb-3">

                                    <label for="transactionPeriod">{{ t('message.transactions.periocity') }}</label>
                                    <select class="form-select form-select-lg"
                                        v-model="store.state.transation.recurrence_period"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                        <option value="">{{ t('message.global.select_option') }}</option>
                                        <option value="day">{{ t('message.transactions.daily') }}</option>
                                        <option value="weekley">{{t('message.transactions.weekley')}}</option>
                                        <option value="biweekly">{{t('message.transactions.biweekley')}}</option>
                                        <option value="monthly">{{t('message.transactions.monthly')}}</option>
                                        <option value="quarterly">{{t('message.transactions.quarteyly')}}</option>
                                        <option value="semi-annual">{{ t('message.transactions.semi_anual') }}</option>
                                        <option value="annual">{{t('message.transactions.annual')}}</option>
                                    </select>

                                </div>

                                <div v-if="store.state.transation.id != '' && store.state.transation.recurrence != '' && store.state.transation.recurrence != 'No'" class="col-11 mx-auto mb-3 rounded"
                                v-bind:class="{
                                            'bg-light': !darkMode,
                                        }">

                                    <p class="text-danger fw-bold mt-2">
                                        {{ t('message.transactions.other_dates') }}
                                    </p>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="transactionUpdateOthers" id="transactionUpdateOthers1" value="just_this" v-model="store.state.transation.howUpdate">
                                        <label class="form-check-label" for="transactionUpdateOthers1">
                                            {{ t('message.transactions.objetive_expense') }}
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="transactionUpdateOthers" id="transactionUpdateOthers2" value="this_after" v-model="store.state.transation.howUpdate">
                                        <label class="form-check-label" for="transactionUpdateOthers2">
                                            {{ t('message.transactions.this_next') }}
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="transactionUpdateOthers" id="transactionUpdateOthers3" value="all" v-model="store.state.transation.howUpdate">
                                        <label class="form-check-label" for="transactionUpdateOthers3">
                                            {{ t('message.transactions.all') }}
                                        </label>
                                    </div>
                                
                                </div>

                                <div class="col-12 mb-3" v-if="!store.state.is_card">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="transactionPayment" v-model="store.state.transation.payed">
                                        <label class="form-check-label" for="transactionPayment">{{ store.state.transation.type == 'receita' ? t('message.transactions.payment_revenue') : t('message.transactions.payment_expense') }}</label>
                                    </div>
                                </div>

                                
                                
                            </div>

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12 text-center mb-n3">
                        <button
                            v-if="!store.state.savingTransaction"
                            @click="submitTransaction()"
                            class="btn"
                            :class="'btn'+store.state.modalColor"
                        >
                            {{ t('message.transactions.add') }}
                        </button>
                        <img v-if="store.state.savingTransaction" :src="loadGif" alt="" width="50">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="detailsTransaction" tabindex="-1" aria-labelledby="detailsTransaction" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content border-4"
                v-bind:class="{
                        'darkmode': darkMode,
                        'border-danger': store.state.transation.type == 'despesa',
                        'border-success': store.state.transation.type == 'receita',
                        'border-gray': store.state.transation.type == 'transferencia'
                    }">

                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">

                    <div class="row align-items-center">
                        <div class="col-5 text-center">
                            <i :class="'fal ' +  store.state.transation.category_icon +' row-transactions-icons fa-3x' " :style="'color:'+store.state.transation.category_color"></i>
                            <br>
                            <b>{{ store.state.transation.description }}</b>
                            <br>
                            <b :class="'text'+store.state.modalColor">{{store.state.transation.type == 'despesa' ? '-': ''}} {{ store.state.transation.amount }}</b>
                        </div>
                        <div class="col-5" v-bind:class="{
                                            'text-white': darkMode,
                                            'text-dark': !darkMode
                                        }">
                            <p class="text-sm fw-bold">
                                <span class="text-muted" v-bind:class="{
                                            'darkmode': darkMode,
                                        }">{{ t('message.global.date') }}</span>
                                <br>
                                {{ formatDate(store.state.transation.date) }}
                            </p>
                            <p class="text-sm fw-bold">
                                <span class="text-muted mt-2" v-bind:class="{
                                            'darkmode': darkMode,
                                        }">{{ t('message.global.bank_account') }}</span>
                                <br>
                                {{ store.state.transation.account_name }}
                            </p>
                            <p class="text-sm fw-bold">
                                <span class="text-muted" v-bind:class="{
                                            'darkmode': darkMode,
                                        }">{{ t('message.menu.category') }}</span>
                                <br>
                                {{ store.state.transation.category_name }}
                            </p>
                            <p v-if="store.state.transation.customer_supplier > 0" class="text-sm fw-bold">
                                <span class="text-muted" v-bind:class="{
                                            'darkmode': darkMode,
                                        }">Cliente</span>
                                <br>
                                {{ store.state.transation.customer_supplier_name }}
                            </p>
                            <p v-if="store.state.transation.observation != ''" class="text-sm fw-bold">
                                <span class="text-muted" v-bind:class="{
                                            'darkmode': darkMode,
                                        }">{{ t('message.transactions.observation') }}</span>
                                <br>
                                <span v-html="addLinebreaks(store.state.transation.observation)"></span>
                            </p>
                        </div>
                        <div class="col-2 text-end align-self-baseline">
                            <a type="button" data-bs-dismiss="modal" @click="clearFields()">
                                <i class="fal fa-times-circle fa-lg"></i>
                            </a>
                        </div>
                        <hr>
                    </div>

                    <div v-if="store.state.transation.recurrence == 'Installments'" class="row text-center align-items-center">
                        <div class="col-4">
                            <p class="fw-bold">
                                {{ t('message.transactions.instaltement') }} {{store.state.transation.current_installment}}/{{store.state.transation.end_installment}}
                            </p>
                        </div>
                        <div class="col-4">
                            <p class=" text-sm fw-bold"
                            v-bind:class="{
                                            'text-dark': !darkMode,
                                            'text-white': darkMode
                                        }">
                                <span class="text-muted" v-bind:class="{
                                            'darkmode': darkMode,
                                        }">{{store.state.transation.type == 'despesa' ? t('message.transactions.instaltement_paid_expense'): t('message.transactions.instaltement_paid_revenue')}}</span>
                                <br>
                                {{ formatMoney(store.state.transation.amount_paid) }}
                            </p>
                        </div>
                        <div class="col-4">
                            <p class="text-dark text-sm fw-bold">
                                <span class="text-muted" v-bind:class="{
                                            'darkmode': darkMode,
                                        }">{{store.state.transation.type == 'despesa' ? t('message.transactions.instaltement_unpaid_expense'): t('message.transactions.instaltement_unpaid_revenue')}}</span>
                                <br>
                                <span class="text-danger">{{ formatMoney(store.state.transation.ammount_unpaid) }}</span>
                            </p>
                        </div>
                        <hr>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            
                            <a data-bs-toggle="modal" data-bs-target="#deleteTransaction" class="float-end">
                                <i 
                                    class="fal fa-trash text-danger row-transactions-icons-actions cursor-pointer"
                                    v-tooltip="{
                                                content:t('message.global.delete'),
                                                distance: 15
                                            }"
                                >
                                </i>
                            </a>
                            <a data-bs-toggle="modal" data-bs-target="#addTransaction" class="me-3 float-end">
                                <i 
                                    class="fal fa-pencil row-transactions-icons-actions cursor-pointer"
                                    v-bind:class="{
                                            'text-black-50': !darkMode,
                                            'text-white-50': darkMode,
                                        }"
                                    v-tooltip="{
                                                content:t('message.global.edit'),
                                                distance: 15
                                            }"
                                    
                                >
                                </i>
                            </a>
                        </div>
                    </div>

                </div>
            
            </div>
        </div>
    </div>

    <div class="modal fade" id="deleteTransaction" tabindex="-1" aria-labelledby="deleteTransactionModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" v-bind:class="{
                        'darkmode': darkMode
                    }">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-11 mx-auto mt-4 mb-4">
                        <h5 class="mb-4" v-html="t('message.transactions.delete_title', {msg: store.state.transation.description})"></h5>
                    </div>
                    <div 
                        class="col-11 mx-auto text-center"
                    >

                        <div  v-if="store.state.transation.recurrence != '' && store.state.transation.recurrence != 'No'" class="d-grid gap-2">
                            <button class="btn btn-light" type="button" @click="deleteTransation(store.state.transation.id, store.state.transation.transaction_id, 'just_this')">{{ t('message.transactions.delete_just_this') }}</button>
                            <button class="btn btn-danger" type="button" @click="deleteTransation(store.state.transation.id, store.state.transation.transaction_id, 'this_after')">{{ t('message.transactions.delete_this_next') }}</button>
                        </div>

                        <a  v-if="store.state.transation.recurrence != '' && store.state.transation.recurrence != 'No'" @click="closeModal('deleteTransaction')" class="btn btn-link">{{ t('message.global.cancel') }}</a>

                        <div  v-if="store.state.transation.recurrence == '' || store.state.transation.recurrence == 'No'" class="d-grid gap-2">
                            <button class="btn btn-danger" type="button" @click="deleteTransation(store.state.transation.id, store.state.transation.transaction_id, 'just_this')">{{ t('message.global.yes') }}</button>
                            <button @click="closeModal('deleteTransaction')" class="btn btn-light" type="button">{{ t('message.global.no') }}</button>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
    </div>

    <div class="modal fade" id="payTransaction" tabindex="-1" aria-labelledby="payTransaction" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-4" v-bind:class="{
                        'darkmode': darkMode,
                        'border-danger': store.state.transation.type == 'despesa',
                        'border-success': store.state.transation.type == 'receita',
                        'border-gray': store.state.transation.type == 'transferencia'
                    }">
                <div class="modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">
                        <div class="col-10">
                            <b>
                                {{store.state.transation.type == 'despesa' ? t('message.transactions.paying_expense'): t('message.transactions.paying_revenue')}}
                            </b>
                        </div>
                        <div class="col-2 text-end">
                            <a type="button" data-bs-dismiss="modal" @click="clearFields()">
                                <i class="fal fa-times-circle fa-lg"></i>
                            </a>
                        </div>

                    </div>

                    <div class="row align-items-center">
                        <div class="col-4 text-center">
                            <i :class="'fal ' +  store.state.transation.category_icon +' row-transactions-icons fa-3x' " :style="'color:'+store.state.transation.category_color"></i>
                            <br>
                            <b>{{ store.state.transation.description }}</b>
                            <br>
                        </div>
                        <div class="col-6">

                            <div class="row">

                                <div class="col-12 mb-3">
                                    <label for="transactionAmount">{{ t('message.transactions.amount') }}</label>
                                    <input 
                                        type="tel" 
                                        class="form-control form-control-lg" 
                                        id="transactionAmount"
                                        name="transactionAmount"
                                        v-model.lazy="store.state.transaction_value.value" 
                                        v-money="money"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 mb-3">
                                    <label for="transactionDate">{{ t('message.global.date') }}</label>
                                    <input 
                                        type="date" 
                                        class="form-control form-control-lg" 
                                        id="transactionDate"
                                        name="transactionDate"
                                        v-model="store.state.transation.date"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div v-if="store.state.transation.type == 'receita' || store.state.transation.type == 'despesa'" class="col-12 mb-3">
                                    <label for="transactionAccount">{{ t('message.transactions.account_card') }}</label>
                                    <select 
                                        class="form-select form-select-lg" 
                                        aria-label="Conta/Cartão" 
                                        v-model="store.state.transation.account"
                                        id="transactionAccount"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                            <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                                            <optgroup label="Contas">
                                                <option
                                                    v-for="(account, index) in store.state.accounts" :key="index"
                                                    :value="account.id+'-bank'"
                                                >
                                                    {{ account.name }}
                                                </option>
                                            </optgroup>

                                            <optgroup label="Cartões">
                                                <option
                                                    v-for="(card, index) in store.state.cards" :key="index"
                                                    :value="card.id+'-card'"
                                                >
                                                    {{ card.name }}
                                                </option>
                                            </optgroup>
                                    </select>
                                    <div id="parentSelectFeedback" class="invalid-feedback">
                                        {{ store.state.validation.parentMessageError }}
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 text-center mb-2">
                            <button
                                v-if="!store.state.savingTransaction"
                                @click="submitTransaction()"
                                class="btn"
                                :class="'btn'+store.state.modalColor"
                            >
                                {{store.state.transation.type == 'despesa' ? t('message.transactions.paying_button_expense') : t('message.transactions.paying_button_revenue')}}
                            </button>
                            <img v-if="store.state.savingTransaction" :src="loadGif" alt="" width="50">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>